import React from 'react';
import { Collapse } from '@material-ui/core';
import FlightSummary from '.';

const FlightsExpanded = ({ expanded, index, flightDetails, passengers }) => {
  return (
    <Collapse in={expanded[index]} timeout={{ enter: 500, exit: 1 }}>
      <FlightSummary flight={flightDetails} passengers={passengers} />
    </Collapse>
  );
};

export default FlightsExpanded;
